import colors from "../colors";

export default {
    ...colors,
    primary: colors["bayou-primary"],
    secondary: colors["bayou-secondary"],
    accent: colors["bayou-accent"],
};
